import React, { createContext, useContext, useLayoutEffect, useRef } from 'react';

/**
 * Shares a detached DOM node that the placement is portaled into.
 * PlacementSlot moves this node into the results list when it mounts.
 */
const PlacementPortalContainerContext = createContext<HTMLDivElement | null>(null);

export const usePlacementPortalContainer = (): HTMLDivElement | null =>
	useContext(PlacementPortalContainerContext);

export const PlacementPortalContainerProvider = PlacementPortalContainerContext.Provider;

/**
 * Moves the pre-mounted placement container into this position in the DOM.
 */
export const PlacementSlot = (): React.JSX.Element | null => {
	const slotRef = useRef<HTMLDivElement>(null);
	const placementContainer = usePlacementPortalContainer();

	useLayoutEffect(() => {
		const slot = slotRef.current;
		if (slot && placementContainer) {
			placementContainer.style.display = '';
			slot.appendChild(placementContainer);
		}
		return () => {
			if (placementContainer) {
				placementContainer.style.display = 'none';
				placementContainer.remove();
			}
		};
	}, [placementContainer]);

	return <div ref={slotRef} />;
};
